import api from "../proxy/config";
import axios from "./axiosConfig";
import {
  parsePaymentMethodListResponse,
  validatePaymentMethodDeleteRequest,
  validatePaymentMethodSaveRequest,
} from "./schemas/adminPaymentMethodsSchemas";

const getHeaders = () => ({
  Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("token"))}`,
});

const adminPaymentMethodsService = {
  listPaymentMethods: async () => {
    const response = await axios.post(api.paymentMethodsList, {}, { headers: getHeaders() });
    return parsePaymentMethodListResponse(response?.data ?? []);
  },

  savePaymentMethod: async (data) => {
    const payload = validatePaymentMethodSaveRequest(data);
    const body = {
      descrizione: payload.descrizione,
      urlLogo: payload.urlLogo?.trim() || null,
    };
    if (payload.id != null) {
      body.id = payload.id;
    }
    return axios.post(api.paymentMethodsSave, body, { headers: getHeaders() });
  },

  deletePaymentMethod: async (id) => {
    const payload = validatePaymentMethodDeleteRequest({ id });
    return axios.post(api.paymentMethodsDelete, payload, { headers: getHeaders() });
  },
};

export default adminPaymentMethodsService;
